import React, { Component, ReactNode } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { BigMarbleRating } from '../marble-rating/BigMarbleRating'
import { apolloClientPrivate } from '../../../graphql/apolloClient'
import { StoreRatingDocument } from './Rating.codegen'
import { ButtonPrimary } from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'

import './Rating.less'

interface IRatingStatus {
  title: string
  component: ReactNode
}

enum RatingStep {
  Rating,
  Feedback,
  Thanks
}

interface IStoreRatingMutationResponse {
  data: {
    enrolment: {
      id: number
      storeRating: {
        rating: number
      }
    }
  }
}

// TODO refactor to FC
// THIS IS NOT UNIVERSAL COMPONENT - used only in topics and scrom
@observer
class Rating extends Component<
  {
    enrolmentId: number
  },
  {
    feedback: string
    sending: boolean
    selectedRating: number
    status: RatingStep
  }
> {
  @observable
  feedback = null
  @observable
  sending = false
  @observable
  selectedRating
  @observable
  status = RatingStep.Rating

  handleFeedback = (e) => {
    this.feedback = e.target.value
  }

  handleSend = async () => {
    try {
      this.sending = true

      await apolloClientPrivate.mutate<IStoreRatingMutationResponse>({
        variables: {
          enrolmentId: this.props.enrolmentId,
          rating: this.selectedRating,
          feedback: this.feedback
        },
        mutation: StoreRatingDocument
      })

      this.status = RatingStep.Thanks
    } catch (e) {
      console.debug(e)
    }
    this.sending = false
  }

  handleChange = (rating: number) => {
    this.selectedRating = rating
    this.status = RatingStep.Feedback
  }

  render() {
    const content = this.getContentForStatus()
    return (
      <div className="Rating">
        <div className="Rating__edit">
          <h4>{content.title}</h4>
          {content.component}
        </div>
      </div>
    )
  }

  private getContentForStatus(): IRatingStatus {
    switch (this.status) {
      case RatingStep.Rating:
        return {
          title: t`How useful did you find this resource?`,
          component: this.renderRating()
        }

      case RatingStep.Feedback:
        return {
          title: t`We'd love to hear your feedback`,
          component: this.renderFeedback()
        }

      case RatingStep.Thanks:
        return {
          title: t`Thank you for your feedback!`,
          component: null
        }
    }
  }

  private renderRating(): ReactNode {
    return (
      <div className="Rating__rating-wrapper">
        <em>
          <Trans>Not useful</Trans>
        </em>
        <BigMarbleRating onChange={this.handleChange} />
        <em>
          <Trans>Very useful</Trans>
        </em>
      </div>
    )
  }

  private renderFeedback(): ReactNode {
    return (
      <>
        <textarea
          placeholder={t`Tell us what we could do to improve`}
          onChange={this.handleFeedback}
        />
        <ButtonPrimary
          mt="12px"
          onClick={this.handleSend}
          isLoading={this.sending}
        >
          {/* don't delete this span, it's essential (if page is translated, and button is clicked it throws error otherwise)*/}
          <span>
            <Trans>Send</Trans>
          </span>
        </ButtonPrimary>
      </>
    )
  }
}

export default Rating
